import { SelectItem } from '../../shared/models/select-item.model';

export class ServiceRequestConstants {
  public static severityOptions: SelectItem[] = [
    {
      name: $localize`:@@common.low:Low`,
      value: '4',
      explanation: $localize`:@@sr_creation.field.severity.explanation_low:Some local users are affected; A workaround is available.`,
    },
    {
      name: $localize`:@@common.medium:Medium`,
      value: '3',
      explanation: $localize`:@@sr_creation.field.severity.explanation_medium:25% of vital operations are stopped or extremely slow. A workaround is available.`,
    },
    {
      name: $localize`:@@common.high:High`,
      value: '2',
      explanation: $localize`:@@sr_creation.field.severity.explanation_high:25-50% of vital operations are stopped or extremely slow. No workaround.`,
    },
    {
      name: $localize`:@@common.critical:Critical`,
      value: '1',
      explanation: $localize`:@@sr_creation.field.severity.explanation_critical:Vital business operations stopped for all or most users. No workaround.`,
    },
  ];

  public static urgencyOptions: SelectItem[] = [
    {
      name: $localize`:@@common.low:Low`,
      value: '4',
      explanation: $localize`:@@sr_creation.field.urgency.explanation_low:Work is only affected slightly.`,
    },
    {
      name: $localize`:@@common.medium:Medium`,
      value: '3',
      explanation: $localize`:@@sr_creation.field.urgency.explanation_medium:Work is reduced.`,
    },
    {
      name: $localize`:@@common.high:High`,
      value: '2',
      explanation: $localize`:@@sr_creation.field.urgency.explanation_high:Work has significantly been reduced.`,
    },
    {
      name: $localize`:@@common.critical:Critical`,
      value: '1',
      explanation: $localize`:@@sr_creation.field.urgency.explanation_critical:Work has stopped.`,
    },
  ];

  public static locationOptions: SelectItem[] = [
    { name: 'Esbjerg', value: 'Esbjerg' },
    { name: 'Odense', value: 'Odense' },
    { name: 'Pabianice', value: 'Pabianice' },
    { name: 'Cologne', value: 'Cologne' },
    { name: 'Stockholm', value: 'Stockholm' },
  ];
}
